import Boleto25BlackBG from '@/components/organisms/Boleto25BlackBG';
import Boleto25BoletoVenceu from '@/components/organisms/Boleto25BoletoVenceu';
import Boleto25DDA from '@/components/organisms/Boleto25DDA';
import Boleto25PassoaPasso from '@/components/organisms/Boleto25PassoaPasso';
import Boleto25Stack from '@/components/organisms/Boleto25Stack';
import Boleto25Video from '@/components/organisms/Boleto25Video';
import Head from 'next/head';
import React from 'react';
import Styles from './BoletoV2.css';
import Boleto25MudancaRazaoSocial from '@/components/organisms/Boleto25MudancaRazaoSocial';

function BoletoV2() {
  return (
    <>
      <Head>
        <title>Gerar Boletos | Santander Financiamentos</title>
        <meta name="robots" content="index,follow" />
        <meta
          name="Description"
          content="Gerencie seus boletos Santander Financiamentos: emita 2ª via, atualize boletos vencidos e consulte parcelas. Acesse a área do cliente e gere seu boleto!"
        />
        <meta
          name="keywords"
          content="boleto, Santander Financiamentos boleto, Boleto Santander Financiamentos, gerar boleto, Segunda via boleto, consultar boleto, Gerar boletos, Boleto vencido, atualizar boleto vencido, validar boleto, boleto falso como identificar, Parcelas financiamento, baixar boleto PDF, 2ª via boleto, 2ª via de boleto, 2ª via boleto Santander Financiamentos, Boleto de financiamento, boleto quitação financiamento Santander"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/boleto.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Gerar Boletos | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/boleto.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Gerencie seus boletos Santander Financiamentos: emita 2ª via, atualize boletos vencidos e consulte parcelas. Acesse a área do cliente e gere seu boleto!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/boleto25/img-boleto-venceu.png"
        />
        <meta
          property="og:image:alt"
          content="Mulher branca de cabelo curto pesquisando sobre vencimento do boleto."
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Gerar Boletos | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Gerencie seus boletos Santander Financiamentos: emita 2ª via, atualize boletos vencidos e consulte parcelas. Acesse a área do cliente e gere seu boleto!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/boleto.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/boleto25/img-boleto-venceu.png"
        />
        <meta
          property="twitter:image:alt"
          content="Mulher branca de cabelo curto pesquisando sobre vencimento do boleto."
        />
        <meta property="twitter:image:type" content="image/png" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Boleto25PassoaPasso />
      <Boleto25BoletoVenceu />
      <Boleto25MudancaRazaoSocial />
      <Boleto25DDA />
      <style jsx>{Styles}</style>
    </>
  );
}

export default BoletoV2;
